import { safeJsonParse } from "./json-parser";
import { logger } from "./logger";

export const setStorageItem = (key: string, value: string): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(key, value);
  } catch (error) {
    logger({
      message: "Error setting item in localStorage",
      error: error as Error,
    });
  }
};

export const getStorageItem = (key: string): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return localStorage.getItem(key);
  } catch (error) {
    logger({
      message: "Error getting item from localStorage",
      error: error as Error,
    });

    return null;
  }
};

export const removeStorageItem = (key: string): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(key);
  } catch (error) {
    logger({
      message: "Error removing item from localStorage",
      error: error as Error,
    });
  }
};

export const setStorageJSON = <T>(key: string, value: T): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const jsonString = JSON.stringify(value);
    localStorage.setItem(key, jsonString);
  } catch (error) {
    logger({
      message: "Error setting item in localStorage",
      error: error as Error,
    });
  }
};

export const getStorageJSON = <T>(key: string): T | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const jsonString = localStorage.getItem(key);
    return jsonString ? safeJsonParse<T>(jsonString) : null;
  } catch (error) {
    logger({
      message: "Error getting item from localStorage",
      error: error as Error,
    });

    return null;
  }
};

export const parseJSON = <T>(jsonString: string): T | null => {
  try {
    return JSON.parse(jsonString) as T;
  } catch (error) {
    console.error("Error parsing JSON string:", error);
    return null;
  }
};
